import { render, staticRenderFns } from "./AnnouncementListPage.vue?vue&type=template&id=7c96c77c&"
import script from "./AnnouncementListPage.vue?vue&type=script&lang=js&"
export * from "./AnnouncementListPage.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementListPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports